import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import MessageRow from '@/components/table/MessageRow';
import WorkflowsDropdown from '@/workflows/components/WorkflowsDropdown';
import DatasetNamespacesDropdown from '../../namespaces/containers/DatasetNamespacesDropdown';
import DatasetTransfersDropdown from '../components/DatasetTransfersDropdown';
import { allowedTransferTypes } from '../helper';
import RequestSettingEnabledWarning from '../components/RequestSettingEnabledWarning';
import { datasetSettingsFields } from '../state/state';
import { datasetManagePermissions } from '../../sharing/constants';
import {
  showWorkflowConfirmation,
  updateDatasetSettings,
} from '../actions';
import { datasourceFields } from '../../datasource/state/state';

const DatasetRequestSettingRows = ({
  canChangeSettings,
  category,
  code,
  confirmWorkflow,
  name,
  datasourceTransferFeatures,
  requestAllowed,
  transferTypes,
  updateSettings,
  workflowKey,
}) => {
  const onWorkflowChange = (workflow) => {
    const key = workflow ? workflow.code : null;
    if (workflowKey) {
      confirmWorkflow(code, category, workflow, name);
    } else {
      updateSettings(category, code, { workflow_key: key }, name);
    }
  };

  return (
    <>
      {!requestAllowed && (<RequestSettingEnabledWarning />)}
      <MessageRow
        collapsing
        context="dataset.setting"
        icons={['sitemap']}
        message="dataset.settings.workflow.field.label"
        entity="requests"
      >
        <WorkflowsDropdown
          direction="left"
          category="lookups"
          workflowKey={workflowKey}
          onChange={onWorkflowChange}
          disabled={!canChangeSettings}
        />
      </MessageRow>
      <MessageRow
        collapsing
        context="dataset.setting"
        icons={['exchange']}
        message="dataset.settings.transfer.types.field.label"
        entity="requests"
      >
        <DatasetTransfersDropdown
          category={category}
          className="min-w-230"
          code={code}
          disabled={!canChangeSettings}
          name={name}
          transferTypes={transferTypes}
          updateDatasetSettings={updateSettings}
          datasourceTransferFeatures={datasourceTransferFeatures}
        />
      </MessageRow>
      <MessageRow
        collapsing
        context="dataset.namespace"
        icons={['lightbulb outline']}
        message="dataset.suggested.namespaces.label"
        entity="requests"
      >
        <DatasetNamespacesDropdown
          category={category}
          code={code}
          disabled={!canChangeSettings}
          name={name}
        />
      </MessageRow>
    </>
  );
};

const mapStateToProps = ({
  datasetSettings: { settings },
  datasetUsers: { permissions },
  datasetDatasource: { features },
}, { category, code }) => {
  const perms = findResult(permissions, category, code) || { ...readStates };
  const item = findResult(settings, category, code) || { ...datasetSettingsFields(), ...saveStates };
  const transferTypes = Object.keys(allowedTransferTypes(item));
  const datasourceTransferFeatures = findResult(features, category, code) || { ...datasourceFields() };

  return ({
    requestAllowed: item.workflow_key && transferTypes.length > 0,
    transferTypes,
    datasourceTransferFeatures: datasourceTransferFeatures?.features?.transfer?.features,
    workflowKey: item.workflow_key,
    canChangeSettings: item.saveStatus !== states.PENDING && perms[datasetManagePermissions.SETTINGS],
  });
};

const mapDispatchToProps = {
  confirmWorkflow: showWorkflowConfirmation,
  updateSettings: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetRequestSettingRows);
